"use strict";

require("core-js/modules/es6.string.fixed");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getHtmlClasses = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _canUseDom = _interopRequireDefault(require("../../services/can-use-dom"));

var _brand = _interopRequireDefault(require("./components/brand"));

var _burger = _interopRequireDefault(require("./components/burger"));

var _menu = _interopRequireDefault(require("./components/menu"));

var _item = _interopRequireDefault(require("./components/item"));

var _dropdown = _interopRequireDefault(require("./components/dropdown"));

var _divider = _interopRequireDefault(require("./components/divider"));

var _link = _interopRequireDefault(require("./components/link"));

var _container = _interopRequireDefault(require("./components/container"));

var _constants = _interopRequireDefault(require("../../constants"));

var _context = require("./context");

var _element = _interopRequireDefault(require("../element"));

var _modifiers = _interopRequireDefault(require("../../modifiers"));

var _renderAs = _interopRequireDefault(require("../../modifiers/render-as"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var colors = [null].concat(Object.keys(_constants["default"].COLORS).map(function (key) {
  return _constants["default"].COLORS[key];
}));
var htmlClass = '';

var getHtmlClasses = function getHtmlClasses() {
  return htmlClass;
};

exports.getHtmlClasses = getHtmlClasses;

var Navbar = function Navbar(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      fixed = _ref.fixed,
      transparent = _ref.transparent,
      color = _ref.color,
      active = _ref.active,
      props = _objectWithoutProperties(_ref, ["children", "className", "fixed", "transparent", "color", "active"]);

  htmlClass = fixed ? "has-navbar-fixed-".concat(fixed) : '';
  (0, _react.useEffect)(function () {
    if (!_canUseDom["default"]) {
      return function () {};
    }

    var html = window.document.querySelector('html');

    if (!html.classList.contains("has-navbar-fixed-".concat(fixed))) {
      html.classList.remove('has-navbar-fixed-top');
      html.classList.remove('has-navbar-fixed-bottom');
    }

    if (fixed) {
      html.classList.add("has-navbar-fixed-".concat(fixed));
    }

    return function () {
      return window.document.querySelector('html').classList.remove("has-navbar-fixed-".concat(fixed));
    };
  }, [fixed]);
  return _react["default"].createElement(_context.ShowContext.Provider, {
    value: active
  }, _react["default"].createElement(_element["default"], _extends({}, props, {
    role: "navigation",
    className: (0, _classnames2["default"])('navbar', _modifiers["default"].classnames(props), className, (_classnames = {
      'is-transparent': transparent
    }, _defineProperty(_classnames, "is-fixed-".concat(fixed), fixed), _defineProperty(_classnames, "is-".concat(color), color), _classnames))
  }), children));
};

Navbar.propTypes = _objectSpread({}, _modifiers["default"].propTypes, {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  style: _propTypes["default"].shape({}),
  transparent: _propTypes["default"].bool,
  renderAs: _renderAs["default"],
  fixed: _propTypes["default"].oneOf(['top', 'bottom']),
  color: _propTypes["default"].oneOf(colors),
  active: _propTypes["default"].bool
});
Navbar.defaultProps = _objectSpread({}, _modifiers["default"].defaultProps, {
  children: null,
  className: undefined,
  style: undefined,
  renderAs: 'nav',
  transparent: false,
  active: false,
  fixed: undefined,
  color: undefined
});
Navbar.Brand = _brand["default"];
Navbar.Burger = _burger["default"];
Navbar.Menu = _menu["default"];
Navbar.Item = _item["default"];
Navbar.Dropdown = _dropdown["default"];
Navbar.Link = _link["default"];
Navbar.Divider = _divider["default"];
Navbar.Container = _container["default"];
var _default = Navbar;
exports["default"] = _default;